import React from 'react'
import Header from '../components/Header'
import { Footer } from '../components/Footer'
import PatientAssesmentPage from '../views/patientInformation/patientAssesmentPage'

const PatientAssement = () => {
    window.scrollTo(0, 0);

    return (
        <>
            <Header />
            <PatientAssesmentPage />
            <Footer />
        </>
    )
}

export default PatientAssement
